<template>
  <span>
    <span class="ag-tooltip" v-if="text && text.length">
      <span v-if="!options.tableShow">
        {{ truncate(text, 8, "...", options.first, options.last) }}
      </span>
      <span v-if="options.tableShow" v-html="options.tableShow(data)"></span>
      <div :class="options.tooltipPosition ? options.tooltipPosition : 'right'" :style="{width: options.width ? options.width : 'inherit' }">
        <span v-if="options.show" v-html="options.show(data)"></span>
        <span v-if="!options.show" style="display: flex;align-items: center;justify-content: center;">
          {{ text }}
          <ag-copy-paste :text="text"></ag-copy-paste>
        </span>
        <i class="indicator"></i>
      </div>
    </span>
    <span v-else>
      <span v-if="options.na">{{ !text ? 'N/A' : '' }}</span>
    </span>
  </span>
</template>

<script>
import AgCopyPaste from "@/components/ag-copy-paste/index.vue";

export default {
  props: {
    text: {},
    options: {},
    data: {},
  },
  components: {
    AgCopyPaste,
  },
  methods: {
    truncate(
      fullStr,
      strLen = 8,
      separator = "...",
      frontChars = 3,
      backChars = 4
    ) {
      if (
        !fullStr ||
        fullStr.length <= strLen ||
        fullStr.length <= frontChars + backChars
      ) {
        return fullStr;
      }

      return (
        fullStr.substr(0, frontChars) +
        separator +
        fullStr.substr(fullStr.length - backChars)
      );
    },
  },
};
</script>

